import * as React from "react"
const HamburgerMenu = (props) => (
	<svg
		width={38}
		height={24}
		viewBox="0 0 38 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width={38} height={4} rx={2} fill="white" />
		<rect y={13} width={38} height={4} rx={2} fill="white" />
		<rect y={26} width={38} height={4} rx={2} fill="white" />
	</svg>
);
export default HamburgerMenu;